import { useCallback } from 'react';

import { useBrandTermsActions } from 'src/store';
import { ROUTES } from 'src/routes';
import { useHistoryPushOrInfinityOpen } from 'src/services';
import { formatBrandVoiceChildRoute } from 'src/lib/routing';

export const useHandlers = ({ onClose, brandVoiceIds }) => {
  const brandTermsActions = useBrandTermsActions();
  const historyPushOrInfinityOpen = useHistoryPushOrInfinityOpen();

  const handleSubmit = useCallback(() => {
    brandTermsActions.setBrandVoiceIdsForBrandTerms(brandVoiceIds);
    onClose();
  }, [brandTermsActions, brandVoiceIds, onClose]);

  const handleRulesSetClick = useCallback(
    (brandVoice) => {
      onClose();
      historyPushOrInfinityOpen(formatBrandVoiceChildRoute(brandVoice.id, ROUTES.BRAND_GUIDELINES));
    },
    [onClose, historyPushOrInfinityOpen]
  );

  return { handleSubmit, handleRulesSetClick };
};
